import styled from '@emotion/styled';
import { Tooltip } from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import ButtonWithIcon from '../../primitive/ButtonWithIcon';

interface Props {
  onClick: () => void;
  disabled: boolean;
}

const BatchDownloadButton: FC<Props> = ({ ...props }) => {
  const button = (
    <StyledSpan>
      <ButtonWithIcon
        icon={CloudDownload}
        color="primary"
        variant="contained"
        style={props.disabled ? { pointerEvents: 'none' } : {}}
        {...props}
      >
        <FormattedMessage id="project_basic_setting_detail.assets.label.download_all" />
      </ButtonWithIcon>
    </StyledSpan>
  );

  return props.disabled ? (
    <FormattedMessage id="project_basic_setting_detail.assets.download_all.disabled_button">
      {(text: string) => (
        <Tooltip title={text} placement="top">
          {button}
        </Tooltip>
      )}
    </FormattedMessage>
  ) : (
    button
  );
};

const StyledSpan = styled('span')({
  marginLeft: 'auto',
});

export default BatchDownloadButton;
